<template>
  <div>
    <confirmar-consulta-btn :modelo="modelo" :confirmed="confirmed" v-if="showButtonConfirm" :confirmar-consulta="confirmarPresenca"/>
    <cancelar-consulta-btn :modelo="modelo"  v-if="showButtonCancel" :cancelar-consulta="cancelar"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment/moment'
import ConfirmarConsultaBtn from '@/components/buttons/ConfirmarConsultaBtn.vue'
import CancelarConsultaBtn from '@/components/buttons/CancelarConsultaBtn.vue'

export default {
  name: 'ConfirmarCancelarConsulta',
  components: { ConfirmarConsultaBtn, CancelarConsultaBtn },
  props: {
    agenda: {
      type: Object,
      required: true
    },
    modelo: {
      type: String,
      default: 'flat'
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    showButtonConfirm () {
      return !this.agenda.configuracoes.agendaConfirmada &&
        this.agenda.configuracoes.solicitaConfirmacao &&
        this.verificarValidadeData(this.agenda.dataHora) &&
        this.showIfNotCanceled() &&
        this.tempoPermiteConfirmar
    },
    showButtonCancel () {
      if (this.agenda.configuracoes.permiteCancelar) {
        return this.showButtonCancelEncerrado
      }
      return false
    },
    showButtonCancelEncerrado () {
      const hoje = moment()
      return (hoje.isBefore(this.agenda.dataHora) && this.showIfNotCanceled())
    },
    confirmed () {
      return this.agenda.configuracoes.agendaConfirmada
    },
    toleranciaMin () {
      return this.funcionalidade.parametros.tempoToleranciaConfirmarPresencaMinutos
    },
    tempoPermiteConfirmar () {
      const minutos = this.funcionalidade.parametros.tempoPermitirConfirmarPresencaMinutos
      return moment(this.agenda.dataHora).subtract(minutos, 'minutes').isBefore(moment())
    }
  },
  methods: {
    async confirmarPresenca () {
      this.$confirm('Deseja confirmar a presença?', 'Confirmação', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.confirmarConsulta()
      }).catch(() => {
      })
    },
    async confirmarConsulta () {
      const res = await this.apiFuncionalidade.confirmarConsulta({
        payload: {
          idAgenda: this.agenda.idAgenda
        }
      })
      if (res.status === true) {
        this.$emit('success', res.data)
      }
    },
    async cancelar () {
      this.$confirm('Sua consulta pode ser cancelada até 48h antes do horário marcado. Tem certeza que deseja cancela-la agora?', 'Cancelar consulta?', {
        confirmButtonText: 'CANCELAR CONSULTA',
        cancelButtonText: 'AINDA NÃO',
        type: 'warning'
      }).then(() => {
        this.cancelarConsulta()
      }).catch(() => {
      })
    },
    async cancelarConsulta () {
      const res = await this.apiFuncionalidade.cancelarConsulta({
        payload: {
          idAgenda: this.agenda.idAgenda
        }
      })
      if (res.status === true) {
        this.$emit('success', res.data)
      }
    },
    verificarValidadeData (data) {
      return moment().isBefore(moment(data).add(this.toleranciaMin, 'minutes'))
    },
    showIfNotCanceled () {
      if (this.agenda.status && this.agenda.status.encerrado && this.agenda.status.encerrado === true) {
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
